/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Portfolio-UI
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 5/3/21
 * Copyright All Rights Reserved
 */

import { formValueSelector } from 'redux-form';
import { INVENTORY_PAGE_CONTROL_FORM } from 'constants/forms';
import history from 'support/history';
import { analysisTypesById } from 'constants/analysisTypes';
import getParamsString from 'support/getParamsString';

const inventoryPageControl = store => next => (action) => {
  const nextAction = next(action);
  const { type } = action;
  if (type === '@@redux-form/CHANGE') {
    const { meta: { form } } = action;
    if (form === INVENTORY_PAGE_CONTROL_FORM) {
      const state = store.getState();
      const selectValues = formValueSelector(INVENTORY_PAGE_CONTROL_FORM);
      const { inventoryId, analysisType } = selectValues(state, 'inventoryId', 'analysisType');
      const nextPathname = `/inventory/${inventoryId}/analysisType/${analysisType}`;
      const { searchParams } = analysisTypesById[analysisType];

      const searchValues = selectValues(
        state,
        ...searchParams
      );
      const nextSearch = getParamsString(searchValues);

      const nextUrl = `${nextPathname}/?${nextSearch}`;
      history.push(nextUrl);
    }
  }
  return nextAction;
};

export default inventoryPageControl;



// WEBPACK FOOTER //
// ./js/middlewares/inventoryPageControl.js